import { styled } from '~/styled'

export const TableFooterCell = styled('td', {
  base: [
    'text-grey-800',
    'font-body',
    'font-semibold',
    'text-left',
    'align-middle'
  ]
})

TableFooterCell.displayName = 'TableFooterCell'
